<template>
  <v-container fluid>
    <v-row align="center"
      ><v-col
        ><v-select
          label="Owner"
          :items="owners"
          :outlined="$store.getters.localSettings('outlinedInputs')"
          v-model="newCf.owner"
          hide-details
      /></v-col>
      <v-col>
        <v-text-field
          label="Name"
          v-model="newCf.name"
          :outlined="$store.getters.localSettings('outlinedInputs')"
          hide-details
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Default Value"
          v-model="newCf.content"
          :outlined="$store.getters.localSettings('outlinedInputs')"
          hide-details
        />
      </v-col>
      <v-col>
        <v-btn :disabled="!isValid" @click="onAddNewCustomField"
          ><v-icon left>mdi-plus</v-icon> Add New Custom Field</v-btn
        >
      </v-col>
    </v-row>

    <v-card outlined>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <confirmation-dialog @onConfirm="onRemove(item)">
            <v-btn icon small class="mx-0">
              <v-icon small color="pink">mdi-delete</v-icon>
            </v-btn>
            <template slot="message">This will remove custom field</template>
          </confirmation-dialog>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="debug">
      <code>{{ customFields }}</code>
    </div>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import ConfirmationDialog from "../../shared/ConfirmationDialog.vue";
const randomize = require("randomatic");
const LIST = gql`
  query ownerCustomFields($filter: CustomFieldFilterType) {
    customFields(filter: $filter) {
      totalCount
      edges {
        node {
          id
          typeId
          name
          owner
          content
        }
      }
    }
  }
`;
const REMOVE_CF = gql`
  mutation deleteCustomField($id: ID!) {
    deleteCustomField(id: $id) {
      id
      typeId
      name
      owner
      content
    }
  }
`;
const CREATE_CF = gql`
  mutation createCustomField($input: CustomFieldInput!) {
    createCustomField(input: $input) {
      id
      typeId
      name
      owner
      content
    }
  }
`;
export default {
  components: { ConfirmationDialog },
  name: "owner-custom-fields",

  props: {
    value: Object,
    default: () => null,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Owner",
          value: "owner",
          name: "owner",
        },
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Default Value",
          value: "content",
          name: "content",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      owners: [
        "CLIENT",
        "SUPPLIER",
        "USER",
        "DOCUMENT",
        "SALES_INVOICE",
        "PURCHASE_INVOICE",
      ],
      newCf: {
        name: "",
        owner: "",
        content: "",
      },
      domain: this.value ? this.value.domain : "",
    };
  },

  computed: {
    items() {
      return this.customFields
        ? this.customFields.edges.map(removeGQLTypename)
        : [];
    },
    isValid() {
      return this.newCf.name != "" && this.newCf.name != "";
    },
  },

  watch: {
    value(newVal) {
      this.domain = newVal.domain;
    },
  },

  methods: {
    onAddNewCustomField() {
      this.$apollo
        .mutate({
          mutation: CREATE_CF,
          variables: {
            input: {
              ...this.newCf,
              domain: this.value.domain,
              typeId: randomize("Aa0", 32),
            },
          },
          refetchQueries: [
            {
              query: LIST,
              variables: { filter: { domain_eq: this.value.domain } },
            },
          ],
        })
        .then(
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom field created.",
          })
        )
        .catch(this.errorHandler);
    },
    onRemove(item) {
      this.$apollo
        .mutate({
          mutation: REMOVE_CF,
          variables: {
            id: item.id,
          },
          refetchQueries: [
            {
              query: LIST,
              variables: { filter: { domain_eq: this.value.domain } },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Custom field removed.",
          });
        })
        .catch(this.errorHandler);
    },
    errorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
  },

  apollo: {
    customFields: {
      query: LIST,
      variables() {
        return {
          filter: {
            domain_eq: this.value.domain,
          },
        };
      },
      skip() {
        return this.domain == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/OwnerCustomFields.vue